import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { BehaviorSubject } from 'rxjs';
import { IStringAnyMap } from '../app.types';
import { BooxService } from './boox.service';

@Injectable({
  providedIn: 'root'
})
export class ImpersonateService {

  public $hasRights : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public $employees : BehaviorSubject<IStringAnyMap[]> = new BehaviorSubject<IStringAnyMap[]>([]);

  public $selected : BehaviorSubject<IStringAnyMap|null> = new BehaviorSubject<IStringAnyMap|null>(null);

  public get selected() : IStringAnyMap|null {
    return this.$selected.getValue();
  }

  public get hasRights() : boolean {
    return this.$hasRights.getValue();
  }
  
  public get employees() : IStringAnyMap[] {
    return this.$employees.getValue();
  }

  constructor(
    private app : AppService,
    private boox : BooxService,
  ) {

    this.app.$features.subscribe((_features) => {
      this.$hasRights.next(_features['IMPERSONATE']);

      if(this.hasRights) {

        this.boox.post('kapa/_proc/get_employees_impersonate', {})
          .subscribe((_response : any) => this.$employees.next(_response['resource']));
      }
      else{
        this.$employees.next([]);
      }
    });

  }
}
